<app-global-alert></app-global-alert>

<global-nav data-automation="main-header" [multiSelect]="false" [contextList]="orgList" [navUrl]="navUrl" [hidden]="isMobile"></global-nav>
<mat-sidenav-container class="app-container">
    <mat-sidenav
        #sidenav
        fixedInViewport="true"
        [fixedTopGap]="isMobile ? 0 : 60"
        [mode]="isLargeScreen() ? 'side' : 'over'"
        [opened]="sidenavOpen"
        class="sidenav-container"
    >
        <header class="sidenav-header">
            <div class="left-column">
                <h1 class="page-title ellipsis" data-automation="listTitle" title="{{ 'device.title' | translate }}">
                    {{ 'device.title' | translate }}
                </h1>
            </div>

            <div class="right-column">
                <button
                    mat-icon-button
                    color="accent"
                    aria-label="Menu"
                    class="toggle-sidenav"
                    data-automation="toggle-sidenav"
                    (click)="sidenav.toggle()"
                >
                    <mat-icon>double_arrow</mat-icon>
                </button>
            </div>
        </header>
        <div class="sidenav-component-container">
            <app-list></app-list>
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <button
            mat-icon-button
            color="accent"
            aria-label="Menu"
            class="toggle-sidenav mobile-btn"
            (click)="sidenav.toggle()"
        >
            <mat-icon>menu</mat-icon>
        </button>
        <div class="main-container" [attr.mobile]="isMobile">
            <router-outlet></router-outlet>
        </div>

        <ngx-global-contact-footer></ngx-global-contact-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
